import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';

import {
  CONFIGURATION_DOCUMENT_TYPE_ACTIONS,
  CONFIGURATION_SUBMISSION_TYPE_ACTIONS,
} from '../actions';
import {
  CONFIGURATION_DOCUMENT_FEATURE_STATE,
  CONFIGURATION_SUBMISSION_FEATURE_STATE,
} from '../feature-state';

import { ConfigSubmissions, DocumentTypes } from '../types';

import { WcgTableValues } from '@shared/interfaces/wcg-table-utils.interface';
import {
  CONFIGURE_DEFAULT_PARAMS,
  DEFAULT_DOCUMENT_TYPES_TABLE_DATA,
  DEFAULT_SUBMISSIONS_TABLE_DATA,
} from '../constants';
import { documentTypesTokenizer, submissionTokenizer } from '../store';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { LoadGridPayload } from '@data-access/shared/types/base-grid.type';

export const documentTypesResolver = (route: ActivatedRouteSnapshot) => {
  const _store = inject(Store<DocumentTypes>);
  const params: WcgTableValues = CONFIGURE_DEFAULT_PARAMS(route);

  _store.dispatch(
    CONFIGURATION_DOCUMENT_TYPE_ACTIONS.setDocumentTypesTableData({
      tableData: DEFAULT_DOCUMENT_TYPES_TABLE_DATA,
    }),
  );

  _store.dispatch(
    CONFIGURATION_DOCUMENT_TYPE_ACTIONS.loadDocumentTypes({
      params,
    }),
  );
  return _store
    .select(CONFIGURATION_DOCUMENT_FEATURE_STATE.selectDocumentTypes)
    .pipe(
      filter((v) => !coerceBooleanProperty(v.loading) && v.data.length > 0),
    );
};

export const documentTypesAdminResolver = (route: ActivatedRouteSnapshot) => {
  const _documentTypesAdminTokenizer = documentTypesTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);
  const _params = _wcgTableUtils.generateTableQueryParams(
    CONFIGURE_DEFAULT_PARAMS(route),
  );
  const _payload: LoadGridPayload = {
    params: _params,
  };
  _documentTypesAdminTokenizer.loadDocumentTypes(_payload);
  return !!_documentTypesAdminTokenizer.$documentTypes();
};

export const submissionsResolver = (route: ActivatedRouteSnapshot) => {
  const _store = inject(Store<ConfigSubmissions>);
  const params: WcgTableValues = CONFIGURE_DEFAULT_PARAMS(route);
  _store.dispatch(
    CONFIGURATION_SUBMISSION_TYPE_ACTIONS.setsubmissionTableData({
      tableData: DEFAULT_SUBMISSIONS_TABLE_DATA,
    }),
  );

  _store.dispatch(
    CONFIGURATION_SUBMISSION_TYPE_ACTIONS.loadSubmissionList({
      params,
    }),
  );

  return _store
    .select(CONFIGURATION_SUBMISSION_FEATURE_STATE.selectSubmissions)
    .pipe(
      filter((v) => !coerceBooleanProperty(v?.loading) && v?.data.length > 0),
    );
};

export const submissionIrisMappingResolver = (
  activatedRoute: ActivatedRouteSnapshot,
) => {
  const _submissionTokenizer = submissionTokenizer();

  const _workspaceTypeId = activatedRoute.paramMap.get('workspaceTypeId');
  const _entityType = activatedRoute.paramMap.get('entityType');

  _submissionTokenizer.getSubmissionTypeIrisMapping(
    _workspaceTypeId!,
    _entityType!,
  );
  _submissionTokenizer.getIrisRoutingGroups();

  return !!(
    _submissionTokenizer.$irisMapping() &&
    !_submissionTokenizer.$isLoading() &&
    _submissionTokenizer.$irisRoutingGroups()
  );
};
